import { Card, CardContent } from '@/components/ui/card';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { RoleBadge } from '@/components/team/role-badge';
import { formatCurrency } from '@/lib/utils';
import type { TeamMember } from '@trinco/shared';

interface MemberCardProps {
  member: TeamMember & {
    dealCount?: number;
    revenueSourced?: number;
    ownedRevenueCad?: number;
    sourcedRevenueCad?: number;
  };
}

export function MemberCard({ member }: MemberCardProps) {
  const initials = member.user?.name
    ?.split(' ')
    .map((n) => n[0])
    .join('')
    .toUpperCase() ?? '?';

  return (
    <Card className="transition-shadow hover:shadow-md">
      <CardContent className="flex items-center gap-4 p-4">
        <Avatar className="h-12 w-12">
          <AvatarImage src={member.user?.avatarUrl ?? undefined} />
          <AvatarFallback>{initials}</AvatarFallback>
        </Avatar>
        <div className="flex-1 min-w-0">
          <p className="font-semibold truncate">{member.user?.name}</p>
          <div className="flex items-center gap-2 mt-1">
            <RoleBadge role={member.role} />
          </div>
          <div className="flex items-center gap-3 mt-2 text-xs text-muted-foreground">
            <span>
              <span className="font-medium text-foreground">Closed</span>{' '}
              {formatCurrency(member.ownedRevenueCad ?? 0, 'CAD')}
            </span>
            <span className="text-muted-foreground/50">·</span>
            <span>
              <span className="font-medium text-foreground">Sourced</span>{' '}
              {formatCurrency(member.sourcedRevenueCad ?? 0, 'CAD')}
            </span>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
